(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
/*!
 * @name JavaScript/NodeJS Merge v1.2.1
 * @author yeikos
 * @repository https://github.com/yeikos/js.merge

 * Copyright 2014 yeikos - MIT license
 * https://raw.github.com/yeikos/js.merge/master/LICENSE
 */

;(function(isNode) {

	/**
	 * Merge one or more objects 
	 * @param bool? clone
	 * @param mixed,... arguments
	 * @return object
	 */

	var Public = function(clone) {

		return merge(clone === true, false, arguments);

	}, publicName = 'merge';

	/**
	 * Merge two or more objects recursively 
	 * @param bool? clone
	 * @param mixed,... arguments
	 * @return object
	 */

	Public.recursive = function(clone) {

		return merge(clone === true, true, arguments);

	};

	/**
	 * Clone the input removing any reference
	 * @param mixed input
	 * @return mixed
	 */

	Public.clone = function(input) {

		var output = input,
			type = typeOf(input),
			index, size;

		if (type === 'array') {

			output = [];
			size = input.length;

			for (index=0;index<size;++index)

				output[index] = Public.clone(input[index]);

		} else if (type === 'object') {

			output = {};

			for (index in input)

				output[index] = Public.clone(input[index]);

		}

		return output;

	};

	/**
	 * Merge two objects recursively
	 * @param mixed input
	 * @param mixed extend
	 * @return mixed
	 */

	function merge_recursive(base, extend) {

		if (typeOf(base) !== 'object')

			return extend;

		for (var key in extend) {

			if (typeOf(base[key]) === 'object' && typeOf(extend[key]) === 'object') {

				base[key] = merge_recursive(base[key], extend[key]);

			} else {

				base[key] = extend[key];

			}

		}

		return base;

	}

	/**
	 * Merge two or more objects
	 * @param bool clone
	 * @param bool recursive
	 * @param array argv
	 * @return object
	 */

	function merge(clone, recursive, argv) {

		var result = argv[0],
			size = argv.length;

		if (clone || typeOf(result) !== 'object')

			result = {};

		for (var index=0;index<size;++index) {

			var item = argv[index],

				type = typeOf(item);

			if (type !== 'object') continue;

			for (var key in item) {

				if (key === '__proto__') continue;

				var sitem = clone ? Public.clone(item[key]) : item[key];

				if (recursive) {

					result[key] = merge_recursive(result[key], sitem);

				} else {

					result[key] = sitem;

				}

			}

		}

		return result;

	}

	/**
	 * Get type of variable
	 * @param mixed input
	 * @return string
	 *
	 * @see http://jsperf.com/typeofvar
	 */

	function typeOf(input) {

		return ({}).toString.call(input).slice(8, -1).toLowerCase();

	}

	if (isNode) {

		module.exports = Public;

	} else {

		window[publicName] = Public;

	}

})(typeof module === 'object' && module && typeof module.exports === 'object' && module.exports);
},{}],2:[function(require,module,exports){
exports.install = function(Vue) {

 Vue.component('pagination', {
  template: require('./src/template.html'),
  data: function() {
    return {
      page: 1
    }
  },
  props: {
    for: {
      type: String,
      required: true
    },
    records: {
      type: Number,
      required: true
    },
    perPage: {
      type: Number,
      required: false,
      default: 25
    },
    chunk: {
      type: Number,
      required: false,
      default: 10
    },
    countText: {
      type: String,
      required: false,
      default: '{count} records'
    }
  },
  computed: {
    pages: function() {

      if (!this.records)
        return [];

      return range(this.paginationStart, this.pagesInCurrentChunk);
    },
    totalPages: function() {
      return this.records?Math.ceil(this.records / this.perPage):1;
    },
    totalChunks: function() {
      return Math.ceil(this.totalPages / this.chunk);
    },
    currentChunk: function() {
      return Math.ceil(this.page / this.chunk);
    },
    paginationStart: function() {
     return ((this.currentChunk-1) * this.chunk) + 1;
   },
   count: function() {
    return this.countText.replace('{count}', this.records);
  },
  pagesInCurrentChunk: function() {
    return this.paginationStart + this.chunk <= this.totalPages?
                         this.chunk:
                         this.totalPages - this.paginationStart + 1;
  }
},
methods: {
  setPage: function(page) {
    if (this.allowedPage(page)) {
      this.page = page;
      this.$dispatch('vue-pagination::' + this.for, page);
      return true;
    }

    return false;
  },
  next: function() {
    return this.setPage(this.page + 1);
  },
  prev: function() {
    return this.setPage(this.page -1);
  },
  nextChunk: function() {
    return this.setChunk(1);
  },
  prevChunk: function() {
    return this.setChunk(-1);
  },
  setChunk: function(direction) {
    this.setPage((((this.currentChunk -1) + direction) * this.chunk) + 1);
  },
  allowedPage: function(page) {
    return page>=1 && page<=this.totalPages;
  },
  allowedChunk: function(direction) {
    return (direction==1 && this.currentChunk<this.totalChunks)
    ||  (direction==-1 && this.currentChunk>1);
  },
  isActive: function(page) {
    return this.page==page;
  }
}
});

}

function range(start, count) {
  return Array.apply(0, Array(count))
  .map(function (element, index) {
   return index + start;
 });
}


},{"./src/template.html":3}],3:[function(require,module,exports){
module.exports = "<div class=\"VuePagination\">\n  <ul v-show=\"totalPages>1\"\n  class=\"pagination VuePagination__pagination\">\n\n  <li class=\"VuePagination__pagination-item VuePagination__pagination-item-prev-chunk\"\n  v-bind:class=\"allowedChunk(-1)?'':'disabled'\">\n  <a href=\"javascript:void(0);\"\n  @click=\"prevChunk()\">&lt;&lt;</a>\n</li>\n\n\n<li class=\"VuePagination__pagination-item VuePagination__pagination-item-prev-page\"\nv-bind:class=\"allowedPage(page-1)?'':'disabled'\">\n<a href=\"javascript:void(0);\"\n@click=\"prev()\">&lt;</a>\n</li>\n\n<li class=\"VuePagination__pagination-item\"\nv-for=\"page in pages\"\nv-bind:class=\"isActive(page)?'active':''\">\n<a href=\"javascript:void(0);\"\n@click=\"setPage(page)\">{{page}}</a>\n</li>\n\n<li class=\"VuePagination__pagination-item VuePagination__pagination-item-next-page\"\nv-bind:class=\"allowedPage(page + 1)?'':'disabled'\">\n<a href=\"javascript:void(0);\"\n@click=\"next()\">&gt;</a>\n</li>\n\n<li class=\"VuePagination__pagination-item VuePagination__pagination-item-next-chunk\"\nv-bind:class=\"allowedChunk(1)?'':'disabled'\">\n<a href=\"javascript:void(0);\"\n@click=\"nextChunk()\">&gt;&gt;</a>\n</li>\n</ul>\n\n<p v-if=\"records>0\"\nclass=\"VuePagination__count\">{{count}}</p>\n</div>\n";

},{}],4:[function(require,module,exports){
String.prototype.ucfirst = require('./lib/helpers/ucfirst');
Array.prototype.diff = require('./lib/helpers/array-diff');

//register partial directive globally
Vue.directive('partial', require('./lib/directives/partial'));

exports.client = require('./lib/v-client-table');
exports.server = require('./lib/v-server-table');

},{"./lib/directives/partial":13,"./lib/helpers/array-diff":23,"./lib/helpers/ucfirst":29,"./lib/v-client-table":67,"./lib/v-server-table":68}],5:[function(require,module,exports){
module.exports = function() {
      return displayableColumns(this.columns.concat(this.customColumns), this.windowWidth, this.columnsDisplay);
}

function displayableColumns(columns, windowWidth, display) {

  if (!display) return columns;

   return columns.filter(function(column) {
     if (!display[column]) return true;

     var range = display[column];
     var operator = range[2];

     var inRange = (!range[0] || windowWidth>=range[0]) &&
                   (!range[1] || windowWidth<range[1]);

     return operator=='not'?!inRange:inRange;
  });

}


},{}],6:[function(require,module,exports){
module.exports = function() {
      return this.templatesKeys.diff(this.columns);
}

},{}],7:[function(require,module,exports){
module.exports = function() {
  return JSON.stringify(this.customQueries);
}

},{}],8:[function(require,module,exports){
module.exports = function() {
  var columns = Object.keys(this.options.listColumns);
  var res = {};

  columns.forEach(function(column) {
    res[column] = {};

    this.options.listColumns[column].forEach(function(item) {
      res[column][item.id] = item.text;
    });
  }.bind(this));

  return res;
};

},{}],9:[function(require,module,exports){
module.exports = function() {
  return this.options.filterByColumn?JSON.stringify(this.query):this.query;
}

},{}],10:[function(require,module,exports){
module.exports = function() {
      return Object.keys(this.options.templates);
}

},{}],11:[function(require,module,exports){
module.exports = function() {
  return Math.ceil(this.count / this.limit);
}

},{}],12:[function(require,module,exports){
 // Defaults are returned from a function to overcome caching issues which might cause data leakage between instances

 module.exports = function(source) {
  return {
   dateColumns:[],
   listColumns:{},
   datepickerOptions:{
    locale: {
      cancelLabel:'Clear'
    }
   },
   perPage:10,
   perPageValues:[10,25,50,100],
   params:{},
   sortable:true,
   trackBy:'$index',
   filterable:true,
   filtersInitialValues:{},
   customFilters:[],
   templates:{},
   compileTemplates:false,
   delay:500,
   dateFormat:"DD/MM/YYYY",
   toMomentFormat:false,
   skin:"table-striped table-bordered table-hover",
   wrapperClasses:"",
   columnsDisplay: {},
   texts:{
    count:"{count} Records",
    filter:"Filter Results:",
    filterPlaceholder:"Search query",
    limit:"Records:",
    page:"Page:",
    noResults:"No matching records",
    filterBy:"Filter by {column}",
    loading:'Loading...',
    defaultOption:'Select {column}'
  },
  sortIcon:{
    base:'glyphicon',
    up: 'glyphicon-chevron-up',
    down: 'glyphicon-chevron-down'
  },
  filterByColumn:false,
  highlightMatches:false,
  orderBy:false,
  footerHeadings:false,
  headings:{},
  pagination: {
    dropdown:false,
    chunk:10
  },
   columnStyles:{},
   headingStyles:{}
}
}



},{}],13:[function(require,module,exports){
module.exports =  {
  params: ['name'],
  // watch changes to name for dynamic partials
  paramWatchers: {
    name:function(value) {
      Vue.options.directives.if.remove.call(this);
      if (value) {
        this.insert(value)
      }
    }
  },

  bind:function() {
    this.anchor = Vue.util.createAnchor('v-partial');
    Vue.util.replace(this.el, this.anchor);
    this.insert(this.params.name);
  },
  insert:function (id) {
    var partial = Vue.util.resolveAsset(this.vm.$options, 'partials', id, true);
    if (partial) {
      this.factory = new Vue.FragmentFactory(this.vm, partial);
      Vue.options.directives.if.insert.call(this);
    }
  },
  unbind:function () {
    if (this.frag) {
      this.frag.destroy()
    }
  }
};
},{}],14:[function(require,module,exports){
module.exports = function(column) {
    if (!(column in this.options.columnStyles))
        return '';

    return this.options.columnStyles[column];
}

},{}],15:[function(require,module,exports){
module.exports = function(data, filters) {

var passing;
var filters = JSON.parse(filters);

 return data.filter(function(row) {

  passing = true;

  this.options.customFilters.forEach(function(filter) {
    var value = this.customQueries[filter.name];
    if (value && !filter.callback(row, value))
      passing = false;
  }.bind(this));

  return passing;

}.bind(this));
}

},{}],16:[function(require,module,exports){
var is_valid_moment_object = require('../helpers/is-valid-moment-object');

module.exports = function(property) {

    if (is_valid_moment_object(property))
      return property.format(this.options.dateFormat);

      return property;
}


},{"../helpers/is-valid-moment-object":27}],17:[function(require,module,exports){
module.exports = function(property, column) {

  if (!this.options.highlightMatches || this.templatesKeys.indexOf(column)>-1)
    return property;

  var query = this.options.filterByColumn?this.query[column]:this.query;

  if (!query) return property;

  query = new RegExp(query,"i");

  property = String(property).replace(query,function(highlight) {
    return "<b class='VueTables__highlight'>" + highlight + "</b>";
  });

  return property;

}

},{}],18:[function(require,module,exports){
module.exports = function(value, column) {
  if (!this.isListFilter(column) || !this.listColumnsObject[column].hasOwnProperty(value))
    return value;

  return this.listColumnsObject[column][value];
}

},{}],19:[function(require,module,exports){
module.exports = function(data) {

	var limit = parseInt(this.limit);
	var page = parseInt(this.page);
	var offset = limit * (page-1);

	return data.slice(offset, limit + offset);
};

},{}],20:[function(require,module,exports){
function wrapTemplate(tpl) {
  return "<span class='VueTables__template'>" +  tpl + "</span>";
}

function getMatches(template) {
  var matches = template.match(/{.+?}/g);

  if (!matches) return false;

  return matches.map(function(match) {
    return match.slice(1,-1);
  });
}

module.exports = function(value, row, column) {


  if (this.templatesKeys.indexOf(column)==-1)
    return value;

  var regex;

  if (typeof this.options.templates[column]=='function') {
    var tpl = this.options.templates[column].bind(this.$root);
    return wrapTemplate(tpl(row));
  }

  console.warn("vue-tables: using strings as templates is deprecated and will be removed in an upcoming release. Please use a function instead.");

  var template = wrapTemplate(this.options.templates[column]);
  var matches = getMatches(this.options.templates[column]);

  if (!matches) return template;

  matches.forEach(function(match) {

    if (row.hasOwnProperty(match)) {

    regex = new RegExp("{"+ match + "}","g");
    template = template.replace(regex,String(row[match]));

  }
  }.bind(this));

  return template;

}
},{}],21:[function(require,module,exports){
var object_filled_keys_count = require('../helpers/object-filled-keys-count');
var is_valid_moment_object = require('../helpers/is-valid-moment-object');

module.exports = function(data, query) {

  var totalQueries = !query?0:1;

  if (this.options.filterByColumn)  {
    query = JSON.parse(query);
    totalQueries = object_filled_keys_count(query);
  }

  if (!totalQueries) {
    this.$dispatch('vue-tables.filtered', data);
    return data;
  }

  var value;
  var found;
  var currentQuery;
  var dateFormat = this.options.dateFormat;
  var filterByDate;
  var isListFilter;
  var filterable = this.options.filterable && typeof this.options.filterable=='object'?
                    this.options.filterable:
                    this.columns;

  var filteredData =  data.filter(function(row, index) {

    found = 0;

    filterable.forEach(function(column) {

      filterByDate = this.options.dateColumns.indexOf(column)>-1 && this.options.filterByColumn;
      isListFilter = this.isListFilter(column) && this.options.filterByColumn;

      value = getValue(row[column], filterByDate, dateFormat);

      currentQuery = this.options.filterByColumn?query[column]:query;

      currentQuery = setCurrentQuery(currentQuery);

      if (currentQuery && foundMatch(currentQuery, value, isListFilter)) found++;

    }.bind(this));

    return found>=totalQueries;

  }.bind(this));

  this.$dispatch('vue-tables.filtered', filteredData);

  return filteredData;
}

function setCurrentQuery(query) {

  if (!query) return '';

  if (typeof query=='string')
    return query.toLowerCase();

  // Date Range

  return query;
}

function foundMatch(query, value, isListFilter) {

  // List Filter
  if (isListFilter)
    return value==query;

  //Text Filter
  if (typeof value=='string')
    return value.indexOf(query)>-1;

  // Date range
  var start = moment(query.start,'YYYY-MM-DD');
  var end = moment(query.end,'YYYY-MM-DD');

  return (value>=start && value<=end);
}

function getValue(val, filterByDate, dateFormat) {

  if (is_valid_moment_object(val)) {
    if (filterByDate) return val;
    return val.format(dateFormat);
  }

  return String(val).toLowerCase();
}

},{"../helpers/is-valid-moment-object":27,"../helpers/object-filled-keys-count":28}],22:[function(require,module,exports){
module.exports = function(data) {

    this.count = data.length;

	 return data;
}

},{}],23:[function(require,module,exports){
module.exports = function(a) {
    return this.filter?this.filter(function(i) {return a.indexOf(i) < 0;}):[];
}

},{}],24:[function(require,module,exports){
module.exports = function(a, b) {
   var ai=0, bi=0;
  var result = [];

  while( ai < a.length && bi < b.length )
  {
     if      (a[ai] < b[bi] ){ ai++; }
     else if (a[ai] > b[bi] ){ bi++; }
     else /* they're equal */
     {
       result.push(a[ai]);
       ai++;
       bi++;
     }
  }

  return result;

}

},{}],25:[function(require,module,exports){
module.exports = function(replacements, template) {
  template = template || require('../table-template.html');

  for (var replacement in replacements) {
    template = template.replace("[[" + replacement + "]]", replacements[replacement]);
  }

return template;

}

},{"../table-template.html":66}],26:[function(require,module,exports){
module.exports = function(obj) {
    // null and undefined are "empty"
    if (obj == null) return true;

    // Assume if it has a length property with a non-zero value
    // that that property is correct.
    if (obj.length > 0)    return false;
    if (obj.length === 0)  return true;

    // Otherwise, does it have any properties of its own?
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }

    return true;
}

},{}],27:[function(require,module,exports){
module.exports = function(val) {
  return val && typeof val.isValid=='function' && val.isValid();
}

},{}],28:[function(require,module,exports){
module.exports = function(obj) {
  var count = 0;
  for (var prop in obj) {
    var isDateRange = typeof obj[prop] == 'object';
    if (isDateRange || (obj[prop] && obj[prop].trim())) count++;
  }
  return count;
}

},{}],29:[function(require,module,exports){
module.exports = function() {
    return this.charAt(0).toUpperCase() + this.slice(1);
}

},{}],30:[function(require,module,exports){
module.exports = function() {

    this.data.forEach(function(row,index) {

      this.customColumns.forEach(function(custom) {

      this.$set('data['+index+'].' + custom, this.options.templates[custom]);
      }.bind(this));

  }.bind(this));

}

},{}],31:[function(require,module,exports){
module.exports = function () {
    for (var i = 0; i < this.$els.table.childNodes.length; i++) {
        if (this.$els.table.childNodes[i].nodeName == 'TBODY')
            this.$compile(this.$els.table.childNodes[i]);
    }
}
},{}],32:[function(require,module,exports){
module.exports = function(text, value) {

   if (!this.options.texts) return '';

   var text = this.options.texts[text];

   if (text && value)
     text = text.replace(/{.+}/,value);

    return text;
}


},{}],33:[function(require,module,exports){
module.exports = function(column) {

  if (!this.options.filterable) return false;

  return this.customColumns.indexOf(column)==-1 &&
  ((typeof this.options.filterable=='boolean' && this.options.filterable) || this.options.filterable.indexOf(column)>-1);
}

},{}],34:[function(require,module,exports){
var merge = require('merge');

module.exports = function() {

  var data =  {
    query:this.query,
    limit:this.limit,
    orderBy:this.orderBy.column,
    ascending: this.orderBy.ascending,
    page:this.page,
    byColumn:this.options.filterByColumn?1:0
  };

data = merge(data, this.options.params, this.customQueries);

  this.$dispatch('vue-tables.loading', data);

   var promise = this.$http.get(this.url, {params:data}).then(function(data) {
    return data.json();
  }.bind(this),  function(e) {
    this.$dispatch('vue-tables.error', e);
  }.bind(this));

  return promise.then(function(data) {
    this.loading = false;
    return this.setData(data);
  });

}

},{"merge":1}],35:[function(require,module,exports){
module.exports = function(value) {
    return this.options.headings.hasOwnProperty(value)?
    this.options.headings[value]:
    value.split("_").join(" ").ucfirst();
  }

},{}],36:[function(require,module,exports){
var intersection = require('../helpers/array-intersection');

module.exports = function() {

  var opts = this.options;

  return opts.dateColumns.length &&
         opts.filterByColumn &&
         (opts.filterable || intersection(opts.filterable, opts.dateColumns).length)
}

},{"../helpers/array-intersection":24}],37:[function(require,module,exports){
module.exports = function() {

  var customQueries = {};

  var init = this.options.filtersInitialValues;

  this.options.customFilters.forEach(function(filter) {
    customQueries[filter.name] = init.hasOwnProperty(filter.name)?init[filter.name]:'';
  });

  return customQueries;
}

},{}],38:[function(require,module,exports){
var merge = require('merge');

module.exports = function() {

  var el;
  var init = this.options.filtersInitialValues;
  var initialValues ;

  var options = {
    autoUpdateInput:false,
    singleDatePicker:false,
    locale: {
      format: this.options.dateFormat
    }
  };

  var datepickerOptions = merge.recursive(this.options.datepickerOptions, options);

  var that = this;

    that.options.dateColumns.forEach(function(column) {
     el =  $(that.$el).find("#VueTables__" + column + "-filter");

      initialValues = {};

      if (init.hasOwnProperty(column)) {

        initialValues = {
          startDate:init[column].start.format(that.options.dateFormat),
          endDate:init[column].end.format(that.options.dateFormat)
        }

       el.text(initialValues.startDate + " - " + initialValues.endDate);
      }

     el.daterangepicker(merge.recursive(datepickerOptions, initialValues));
     el.on('apply.daterangepicker', function(ev, picker) {

      that.query[column] = {
        start:picker.startDate.format('YYYY-MM-DD'),
        end: picker.endDate.format('YYYY-MM-DD')
      };

      $(this).text(picker.startDate.format(that.options.dateFormat) + " - " + picker.endDate.format(that.options.dateFormat));

      that.search();
    });

     el.on('cancel.daterangepicker', function(ev, picker) {
      that.query[column] = '';
      $(this).html("<span class='VueTables__filter-placeholder'>" + that.display('filterBy',that.getHeading(column) + "</span>"));

      that.search();
      });

   });


}

},{"merge":1}],39:[function(require,module,exports){
var merge = require('merge');

     module.exports = function(defaults, globalOptions, localOptions) {

      if (globalOptions)
       defaults = merge.recursive(defaults, globalOptions);

     localOptions = merge.recursive(defaults, localOptions);

     return localOptions;

   }

},{"merge":1}],40:[function(require,module,exports){
module.exports = function(column) {

  if (!this.options.orderBy) {
     this.orderBy.column = column;
    return;
  }

  this.orderBy.column = this.options.orderBy.column;
  this.orderBy.ascending = this.options.orderBy.ascending?1:-1;

}

},{}],41:[function(require,module,exports){
module.exports = function() {

  var init = this.options.filtersInitialValues;

  if (!this.options.filterByColumn)
    return init.hasOwnProperty('GENERIC')?init.GENERIC:'';

  var query = {};

  var filterable = this.options.filterable && typeof this.options.filterable=='object'?
                   this.options.filterable:
                   this.columns;

  filterable.forEach(function(column) {
     query[column] = getInitialValue(init, column);
    }.bind(this));

  return query;
}

function getInitialValue(init, column) {

  if (!init.hasOwnProperty(column)) return '';

  if (typeof init[column].start == 'undefined') return init[column];

  return {
    start: init[column].start.format('YYYY-MM-DD'),
    end: init[column].end.format('YYYY-MM-DD')
  }

}

},{}],42:[function(require,module,exports){
module.exports = function() {

  var customQueries = {};
  var init = this.options.filtersInitialValues;

  this.options.customFilters.forEach(function(filter) {
    customQueries[filter] = init.hasOwnProperty(filter)?init[filter]:'';
  });

  return customQueries;
}

},{}],43:[function(require,module,exports){
module.exports = function(column) {
  return this.options.dateColumns.indexOf(column)>-1
}

},{}],44:[function(require,module,exports){
module.exports = function(column) {
  return this.options.listColumns.hasOwnProperty(column);
}

},{}],45:[function(require,module,exports){
module.exports = function(column) {
    //check if this column is a template
    if (this.templatesKeys.indexOf(column)==-1)
        return false;

    if(typeof this.options.templates[column]!='object')
        return false;

    return this.options.templates[column].type == 'partial';
}
},{}],46:[function(require,module,exports){
module.exports = function(column) {
  return this.options.dateColumns.indexOf(column)==-1 &&
         !this.options.listColumns.hasOwnProperty(column);
}

},{}],47:[function(require,module,exports){
module.exports = function(colName) {

  if (!this.sortable(colName))
    return;

  if (colName==this.orderBy.column) {
    this.orderBy.ascending = this.orderBy.ascending==1?-1:1;
  }

  this.orderBy.column = colName;

  if (this.source=='server') {

   this.getData();

 }


}

},{}],48:[function(require,module,exports){
module.exports = function() {
  this.search(this.byColumn);
}

},{}],49:[function(require,module,exports){
module.exports = function() {

  this.options.customFilters.forEach(function(filter) {

    this.$on('vue-tables.filter::' + filter.name, function(value) {
      this.setPage(1);
       this.customQueries[filter.name] = value;
    }.bind(this));

  }.bind(this))




}

},{}],50:[function(require,module,exports){
module.exports = function() {

  this.options.customFilters.forEach(function(filter) {
        this.$on('vue-tables.filter::' + filter, function(value) {
          this.customQueries[filter] = value;
          this.refresh();
        }.bind(this));
  }.bind(this));
}

},{}],51:[function(require,module,exports){
module.exports = function(row) {
  this.$dispatch('vue-tables.row-click', row);
}

},{}],52:[function(require,module,exports){
module.exports = function() {

 this.setPage(1);

 if (this.source=='server' && this.options.pagination.dropdown) {
   this.getData();
}

}

},{}],53:[function(require,module,exports){
module.exports = function() {

  var expressions = ['count','limit','page','orderBy.column','orderBy.ascending'];

  expressions.forEach(function(expression) {
       this.$watch(expression, function(){

        setTimeout(function() {
        this.compileTemplates();

      }.bind(this),0)
      });
     }.bind(this));

}
},{}],54:[function(require,module,exports){
module.exports =  function(data) {
  this.data = data.data;
  this.count = data.count;

  this.addCustomColumns();

  setTimeout(function(){
    this.$dispatch('vue-tables.loaded',data);
  }.bind(this),0);

}

},{}],55:[function(require,module,exports){
module.exports = function(page) {

  this.page = page;

  if (!this.options.pagination.dropdown) {
   this.$refs.pagination.page = page;
 }

 if (this.source=='server') {
   this.getData();
 }

}

},{}],56:[function(require,module,exports){
module.exports = function(column) {

    var cls = this.options.sortIcon.base + ' ';

    if (!this.sortable(column))
    return;

    if (column!=this.orderBy.column) return cls;

    cls+= this.orderBy.ascending==1?
          this.options.sortIcon.up:
          this.options.sortIcon.down;

    return cls;
  }

},{}],57:[function(require,module,exports){
module.exports = function(column) {

   var cssClass = this.sortable(column)?'VueTables__sortable':'';
   var moreClasses = '';

   //apply heading style for this column, if any
   if (column in this.options.headingStyles)
      moreClasses = this.options.headingStyles[column];
   //else apply column style for this column, if any
   else if(column in this.options.columnStyles)
      moreClasses = this.options.columnStyles[column];

   //if both strings are empty return empty string without space to avoid errors
   if(cssClass.length < 1 && moreClasses.length < 1 )
      return '';

   return cssClass + ' ' + moreClasses;
}

},{}],58:[function(require,module,exports){
module.exports = function(column) {

   var isCustomColumn = this.customColumns.indexOf(column)>-1;

    if (isCustomColumn) return false;

    var sortAll = typeof this.options.sortable === 'boolean' &&  this.options.sortable;

    if (sortAll) return true;

    return this.options.sortable.indexOf(column)>-1;

}

},{}],59:[function(require,module,exports){
module.exports = function() {
  this.data.forEach(function(row, index) {
    this.options.dateColumns.forEach(function(column) {
      row[column] = moment(row[column], this.options.toMomentFormat);
    }.bind(this));
  }.bind(this));
}

},{}],60:[function(require,module,exports){
module.exports = {
  computed: {
    listColumnsObject: require('../computed/list-columns-object'),
    allColumns: require('../computed/all-columns'),
    customColumns: require('../computed/custom-columns'),
    templatesKeys: require('../computed/templates-keys')
  }
}

},{"../computed/all-columns":5,"../computed/custom-columns":6,"../computed/list-columns-object":8,"../computed/templates-keys":10}],61:[function(require,module,exports){
var is_empty = require('../helpers/is-empty');

module.exports = {

  created: function() {

    if (is_empty(this.options.columnsDisplay))  return;

    this.columnsDisplay = getColumnsDisplay(this.options.columnsDisplay);

    window.addEventListener('resize', function() {
        this.windowWidth = window.innerWidth;
      }.bind(this));
  }
}

function getColumnsDisplay(columnsDisplay) {
     var res = {};
     var range;
     var device;
     var operator;

    for (var column in columnsDisplay) {
      operator = getOperator(columnsDisplay[column]);
      try {
      device = getDevice(columnsDisplay[column]);
      range = getRange(device, operator);
      res[column] = range.concat([operator]);
      } catch (err) {
        console.warn('Unknown device ' + device);
      }

    }

    return res;
}


function getRange(device, operator) {

  var devices = {
    desktop:[1024, null],
    tablet:[480, 1024],
    mobile:[0, 480],
    tabletL:[768, 1024],
    tabletP:[480, 768],
    mobileL:[320, 480],
    mobileP:[0, 320]
  }

    switch (operator) {
      case 'min':
      return [devices[device][0], null];
      case 'max':
      return [0, devices[device][1]];
      default:
      return devices[device];
    }

}

function getOperator(val) {

    var pieces = val.split('_');

    if (['not','min','max'].indexOf(pieces[0])>-1)
      return pieces[0];

    return false;
}

function getDevice(val) {
    var pieces = val.split('_');
    return pieces.length>1?pieces[1]:pieces[0];
}

},{"../helpers/is-empty":26}],62:[function(require,module,exports){
module.exports = {
  data: function() {
      return {
        id: makeId(),
        customColumns:[],
        allColumns:[],
        customQueries:{},
        totalPages:null,
        query:null,
        page:1,
        count:0,
        limit:10,
        windowWidth:window.innerWidth,
         orderBy: {
          column:'id',
          ascending:1
        }
      }
}
}

function makeId()
{
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for( var i=0; i < 5; i++ )
        text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
}

},{}],63:[function(require,module,exports){
module.exports =   {
    filters: {
      render: require('../filters/render'),
      highlightMatches: require('../filters/highlight-matches'),
      optionText: require('../filters/option-text'),
      columnStyle: require('../filters/column-style')
    }
}
},{"../filters/column-style":14,"../filters/highlight-matches":17,"../filters/option-text":18,"../filters/render":20}],64:[function(require,module,exports){
module.exports =   {
  methods: {
      initQuery: require('../methods/init-query'),
      initOptions: require('../methods/init-options'),
      sortableClass: require('../methods/sortable-class'),
      sortableChevronClass: require('../methods/sortable-chevron-class'),
      display:require('../methods/display'),
      orderByColumn: require('../methods/order-by-column'),
      getHeading: require('../methods/get-heading'),
      addCustomColumns: require('../methods/add-custom-columns'),
      sortable: require('../methods/sortable'),
      search: require('../methods/search'),
      initOrderBy: require('../methods/init-order-by'),
      compileTemplates: require('../methods/compile-templates'),
      initDateFilters: require('../methods/init-date-filters'),
      setPage: require('../methods/set-page'),
      filterable: require('../methods/filterable'),
      isTextFilter: require('../methods/is-text-filter'),
      isDateFilter: require('../methods/is-date-filter'),
      isListFilter: require('../methods/is-list-filter'),
      hasDateFilters: require('../methods/has-date-filters'),
      rowWasClicked: require('../methods/row-was-clicked'),
      isPartialTemplate: require('../methods/is-partal-template')
  }
}
},{"../methods/add-custom-columns":30,"../methods/compile-templates":31,"../methods/display":32,"../methods/filterable":33,"../methods/get-heading":35,"../methods/has-date-filters":36,"../methods/init-date-filters":38,"../methods/init-options":39,"../methods/init-order-by":40,"../methods/init-query":41,"../methods/is-date-filter":43,"../methods/is-list-filter":44,"../methods/is-partal-template":45,"../methods/is-text-filter":46,"../methods/order-by-column":47,"../methods/row-was-clicked":51,"../methods/search":52,"../methods/set-page":55,"../methods/sortable":58,"../methods/sortable-chevron-class":56,"../methods/sortable-class":57}],65:[function(require,module,exports){
module.exports = {
  ready: function() {

    this.$on('vue-pagination::' + this.id, function(page) {
     this.setPage(page);
   }.bind(this));

    this.$compile(this.$els.headings);
  }
}

},{}],66:[function(require,module,exports){
module.exports = "<div class=\"VueTables VueTables--[[source]]\">\n  <div class=\"row\">\n    <div class=\"col-md-6\">\n      <div v-if=\"!options.filterByColumn && options.filterable\" class=\"form-group form-inline pull-left VueTables__search\">\n        <label>{{display('filter')}}</label>\n        <input class=\"form-control\"\n        type=\"text\"\n        placeholder=\"{{display('filterPlaceholder')}}\"\n        @keydown=\"search() | debounce options.delay\"\n        v-model=\"query\"/>\n      </div>\n    </div>\n\n    <div class=\"col-md-6\">\n      <div v-if=\"options.pagination && options.pagination.dropdown && totalPages>0\"\n        class=\"form-group form-inline pull-right VueTables__dropdown-pagination\">\n        <label>{{display('page')}}</label>\n        <select class=\"form-control\"\n        v-model=\"page\"\n        @change=\"setPage(page)\">\n        <option v-for=\"page in totalPages\">{{page+1}}</option>\n      </select>\n    </div>\n\n    <div class=\"form-group form-inline pull-right VueTables__limit\">\n     <label>{{display('limit')}}</label>\n     <select class=\"form-control\"\n     v-model=\"limit\"\n     @change=\"setPage(1)\" >\n     <option v-for=\"value in options.perPageValues\">{{value}}</option>\n   </select>\n </div>\n</div>\n</div>\n\n<div class=\"VueTables__table-wrapper\" v-bind:class=\"options.wrapperClasses\">\n  <table class=\"VueTables__table table\" v-bind:class=\"options.skin\" v-el:table>\n    <thead>\n      <tr v-el:headings>\n       <th @click=\"orderByColumn(column)\"\n       v-for=\"column in allColumns\"\n       v-bind:class=\"sortableClass(column)\"><span class=\"VueTables__heading\">{{{getHeading(column)}}}</span>\n       <span v-if=\"sortable(column)\"\n       class=\"VueTables__sort-icon pull-right\"\n       v-bind:class=\"sortableChevronClass(column)\"></span></th>\n     </tr>\n     <tr v-if=\"options.filterByColumn\" class=\"VueTables__filters-row\">\n      <th v-for=\"column in allColumns\">\n        <div class=\"VueTables__column-filter VueTables__{{column}}-filter-wrapper\" v-if=\"filterable(column)\">\n          <input @keydown=\"search() | debounce options.delay\"\n          v-if=\"isTextFilter(column)\"\n          class=\"form-control\"\n          type=\"text\"\n          placeholder=\"{{display('filterBy',getHeading(column))}}\"\n          v-model=\"query[column]\">\n\n          <div class=\"VueTables__date-filter\"\n          id=\"VueTables__{{column}}-filter\"\n          v-if=\"isDateFilter(column)\">\n          <span class=\"VueTables__filter-placeholder\">{{display('filterBy',getHeading(column))}}</span>\n        </div>\n\n        <div class=\"VueTables__list-filter\"\n        id=\"VueTables__{{column}}-filter\"\n        v-if=\"isListFilter(column)\">\n        <select class='form-control'\n        @change=\"search()\"\n        v-model=\"query[column]\">\n        <option value=\"\">{{display('defaultOption',getHeading(column))}}</option>\n        <option v-for=\"option in options.listColumns[column]\" value=\"{{option.id}}\">{{option.text}}</option>\n      </select>\n    </div>\n\n  </div>\n</th>\n</tr>\n</thead>\n<tfoot v-if=\"options.footerHeadings\">\n <tr>\n   <th @click=\"orderByColumn(column)\"\n   v-for=\"column in allColumns\"\n   v-bind:class=\"sortableClass(column)\"><span class=\"VueTables__heading\">{{getHeading(column)}}</span>\n   <span v-if=\"sortable(column)\"\n   class=\"VueTables__sort-icon pull-right\"\n   v-bind:class=\"sortableChevronClass(column)\"></span></th>\n </tr>\n</tfoot>\n<tbody v-for=\"row in data [[rowFilters]]\" [[trackBy]]>\n <tr @click='rowWasClicked(row)'>\n   <td v-for=\"column in allColumns\" :class=\"column | columnStyle\">\n       <template v-if=\"isPartialTemplate(column)\">\n           <partial :name=\"options.templates[column].name\"></partial>\n       </template>\n       <template v-else>\n           {{{ row[column] | render row column [[columnFilters]] }}}\n       </template>\n   </td>\n </tr>\n\n <tr v-partial :name=\"options.appends\"></tr>\n</tbody>\n<tbody>\n <tr v-if=\"count==0\"\n     class=\"VueTables__no-results\">\n     <td class=\"text-center\"\n         colspan=\"{{allColumns.length}}\">\n         {{display([[loading]]'noResults')}}\n     </td>\n </tr>\n</tbody>\n</table>\n</div>\n\n<pagination\nv-ref:pagination\nv-if=\"options.pagination && !options.pagination.dropdown\"\n:for=\"id\"\n:records=\"count\"\n:per-page=\"parseInt(limit)\"\n:chunk=\"options.pagination.chunk\"\n:count-text=\"options.texts.count\">\n</pagination>\n\n<div v-if=\"count>0 && options.pagination.dropdown\" class=\"VuePagination\">\n  <p class=\"VuePagination__count\">{{display('count', count)}}</p>\n</div>\n\n</div>";

},{}],67:[function(require,module,exports){
var methods = require('./mixins/methods');
var filters = require('./mixins/filters');
var computed = require('./mixins/computed');
var data = require('./mixins/data');
var created = require('./mixins/created');
var ready = require('./mixins/ready');
var template = require('./helpers/generate-table-html');
var VuePagination = require('v-pagination');

exports.install = function(Vue, globalOptions, customOptions) {

  Vue.use(VuePagination);

  var customTemplate = customOptions && customOptions.template
    ? customOptions.template
    : undefined;

  var client = {

    template: template({
      source:'Client',
      rowFilters:'| customFilters customQ | search q | orderBy orderBy.column orderBy.ascending | setCount | page',
      trackBy:':track-by="options.trackBy"',
      columnFilters:'| date | optionText column | highlightMatches column',
      loading:''
    }, customTemplate),
    mixins:[data, methods, filters, computed, created, ready],
    props: {
      columns:{
        type: Array,
        required:true
      },
      data: {
        type: Array,
        required: true
      },
      options: {
        type: Object,
        required:false,
        default: function() {
          return {}
        }
      }
    },

    created: function() {

      /**
       * no need for this yet.
       * methods = events, filters = global filters
       * */
      //bind methods form options to this instance
      /*var _ = require('lodash');
      _.each(this.options.methods, function (method, methodName) {
        //bind only if it doesn't override existing object keys
        if(!(methodName in this)){
          this[methodName] = method;
        }
      }.bind(this));*/

      // merge options (pre-defined defaults, global and local)
      var defaults = require('./config/defaults')('client');
      this.options = this.initOptions(defaults, globalOptions, this.options);

      if (this.options.compileTemplates)
        this.setClientWatchers();

      this.limit = this.options.perPage;

      this.addCustomColumns();

      this.initOrderBy(this.columns[0]);

      // initialize query as a string or an object depending on options.filterByColumn
      this.query = this.initQuery();
      this.customQueries = this.initClientFilters();

      this.count = this.data.length;

    },

    ready: function() {
     this.$watch('query',function() {
      this.setPage(1);
     }.bind(this), {deep:true});

       this.registerClientFilters();

       if (this.hasDateFilters())
        this.initDateFilters();

      if (this.options.dateColumns.length && this.options.toMomentFormat) {
        this.transformDateStringsToMoment();
      }

    },

    data: function() {
      return {
        source:'client'
      }
    },
    computed: {
      q:require('./computed/q'),
      customQ: require('./computed/custom-q'),
      totalPages: require('./computed/total-pages')
    },

    filters: {
      page:require('./filters/page'),
      setCount:require('./filters/set-count'),
      date: require('./filters/date'),
      search: require('./filters/search'),
      customFilters: require('./filters/custom-filters')
    },

    methods: {
      setClientWatchers: require('./methods/set-client-watchers'),
      transformDateStringsToMoment: require('./methods/transform-date-strings-to-moment'),
      registerClientFilters: require('./methods/register-client-filters'),
      initClientFilters: require('./methods/init-client-filters')
    }

  }

  Vue.component('v-client-table',client);

}



},{"./computed/custom-q":7,"./computed/q":9,"./computed/total-pages":11,"./config/defaults":12,"./filters/custom-filters":15,"./filters/date":16,"./filters/page":19,"./filters/search":21,"./filters/set-count":22,"./helpers/generate-table-html":25,"./methods/init-client-filters":37,"./methods/register-client-filters":49,"./methods/set-client-watchers":53,"./methods/transform-date-strings-to-moment":59,"./mixins/computed":60,"./mixins/created":61,"./mixins/data":62,"./mixins/filters":63,"./mixins/methods":64,"./mixins/ready":65,"v-pagination":2}],68:[function(require,module,exports){
var methods = require('./mixins/methods');
var filters = require('./mixins/filters');
var computed = require('./mixins/computed');
var data = require('./mixins/data');
var created = require('./mixins/created');
var ready = require('./mixins/ready');
var template = require('./helpers/generate-table-html');
var VuePagination = require('v-pagination');

exports.install = function(Vue, globalOptions, customOptions) {

  Vue.use(VuePagination);

  var customTemplate = customOptions && customOptions.template
  ? customOptions.template
  : undefined;

  var server = {
    template: template({
      source:'Server',
      rowFilters:'',
      trackBy:'',
      columnFilters:'| optionText column | highlightMatches column',
      loading:"loading?'loading':"
    }, customTemplate),
    mixins:[data, methods, filters,computed, created, ready],
    props: {
     columns:{
      type: Array,
      required:true
    },
    url: {
      type: String,
      required: true
    },
    options: {
      type: Object,
      required:false,
      default: function()
      {
        return {}
      }
    }
  },
  created: function() {

      // merge options (pre-defined defaults, global and local)
      var defaults = require('./config/defaults')('server');
      this.options = this.initOptions(defaults, globalOptions, this.options);
      this.query = this.initQuery();

      if (this.options.compileTemplates)
        this.$on('vue-tables.loaded', function() {
          this.compileTemplates();
        });

      this.initOrderBy(this.columns[0]);

      // set initial records per page
      this.limit = this.options.perPage;

      // initialize query as a string or an object depending on options.filterByColumn
      this.customQueries = this.initServerFilters();

      if (this.hasDateFilters()) {
       setTimeout(function() {
        this.initDateFilters();
      }.bind(this),0);
     }
      // request data for the first time
      this.getData();

    },
    ready: function() {

      this.registerServerFilters();
    },
    data: function() {
      return {
        source:'server',
        data:[],
        loading:true,
        lastKeyStrokeAt:false
      }
    },

    methods: {
     refresh: require('./methods/refresh'),
     getData:require('./methods/get-data'),
     setData:require('./methods/set-data'),
     registerServerFilters: require('./methods/register-server-filters'),
     initServerFilters: require('./methods/init-server-filters')
   },
   computed: {
    totalPages: require('./computed/total-pages')
  }

}

Vue.component('v-server-table', server);

}



},{"./computed/total-pages":11,"./config/defaults":12,"./helpers/generate-table-html":25,"./methods/get-data":34,"./methods/init-server-filters":42,"./methods/refresh":48,"./methods/register-server-filters":50,"./methods/set-data":54,"./mixins/computed":60,"./mixins/created":61,"./mixins/data":62,"./mixins/filters":63,"./mixins/methods":64,"./mixins/ready":65,"v-pagination":2}],69:[function(require,module,exports){
'use strict';

//vue-tables, used only in forms index ATM
var texts = {
    count: Lang.get('labels.vue_tables.count'),
    filter: Lang.get('labels.vue_tables.filter'),
    filterPlaceholder: Lang.get('labels.vue_tables.filterPlaceholder'),
    limit: Lang.get('labels.vue_tables.limit'),
    noResults: Lang.get('labels.vue_tables.noResults'),
    page: Lang.get('labels.vue_tables.page'),
    filterBy: Lang.get('labels.vue_tables.filterBy'),
    loading: Lang.get('labels.vue_tables.loading'),
    defaultOption: Lang.get('labels.vue_tables.defaultOption')
};

var options = {
    texts: texts,
    wrapperClasses: { 'table-responsive': true }
};

Vue.use(require('vue-tables').client, options);
Vue.use(require('vue-tables').server, options);

},{"vue-tables":4}]},{},[69]);

//# sourceMappingURL=vue-tables.js.map
